import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import SectionTitle from "@/components/base/SectionTitle";
import { booklists } from "@/mocks/mangaData";

export default function Booklist() {
  return (
    <>
      <Navbar />
      <main className="mx-auto w-full max-w-7xl px-4 py-8 md:px-6 md:py-12">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "推荐书单" }]} />
        <div className="mt-6">
          <SectionTitle
            eyebrow="推荐书单"
            title="按口味入座的精选书单"
            desc="编辑每周根据新番口碑、完结口碑与读者反馈持续扩充，每份书单都附简介与适合人群，帮你快速判断是否合口味。"
          />
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {booklists.map((b) => (
            <article
              key={b.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300 sm:flex-row"
            >
              <div className="h-56 w-full shrink-0 overflow-hidden sm:h-auto sm:w-52">
                <img
                  src={b.cover}
                  alt={`${b.title}封面`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="w-fit rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800">
                  {b.tag}
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{b.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-7 text-foreground-600">{b.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-2">
                    <i className="ri-bookmark-line"></i>
                    {b.count} 部作品
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-secondary-500"></i>
                    平均 {b.rating}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-2xl border border-dashed border-background-300 bg-background-100 p-6 text-center">
          <h3 className="font-heading text-base font-bold text-foreground-950">还没有想看的方向？</h3>
          <p className="mt-2 text-sm text-foreground-600">
            去热门话题和评论区逛逛，看看同好们最近都在安利什么，或许下一份心动书单就在这里。
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}